import { getAuth, onIdTokenChanged } from 'firebase/auth';

const auth = getAuth();

export const authTokenListener = (/* store not needed */) => {
  onIdTokenChanged(auth, async (user) => {
    if (user) {
      const token = await user.getIdToken(false); // no force refresh
      if (token) localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  });
};
